import { styled } from '@mui/material/styles'
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

import btn from './close.png'

const Img = styled('img')({
  width: 28,
  height: 28,
})
const close = <Img src={btn} alt="close" />

export default function CloseButton(props: IconButtonProps) {
  return (
    <IconButton {...props}>
      { close }
    </IconButton>
  )
}
